/* eslint-disable react/require-default-props */
import { get } from 'lodash/fp';
import { H2, Image, PortableText } from '@ahmdigital/ui';
import React from 'react';
import styled from 'styled-components';

import getFootnoteSerializer from '../../../utils/get-footnote-serializer';
import insertFootnoteReference from '../../../utils/insert-footnote-reference';
import WrappedSection from '../wrapped-section';
import type { ImageType } from '../../../types/image';
import type { PortableTextType } from '../../../types/sanityInternal';

const StyledContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  .footnote {
    bottom: 1rem;
    font-family: ${({ theme }) => theme.fontFamilies.base};
    font-size: 1.5rem;
    padding-left: 0.5rem;
    position: relative;
    text-decoration: none;

    &:hover {
      textdecoration: underline;
    }
  }
`;

const StyledH2 = styled(H2)`
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  text-align: center;
  padding: 2rem 0;

  &.hasImage {
    padding: 1rem;
  }
`;

const StyledImageWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1 0 auto;
  justify-content: center;
  padding-left: 1rem;
  padding-right: 1rem;
  text-align: center;
`;

type StripSectionProps = {
  footnote?: {
    linkId: string;
    reference: string;
  };
  image?: ImageType;
  title?: string | PortableTextType[];
};

const StripSection = ({ footnote, image, title }: StripSectionProps) => {
  const hasImage = get('src', image);

  return (
    <WrappedSection withBorder withInvert withWide variant={['paddingTopSpacer10', 'paddingBottomSpacer10']}>
      <StyledContainer>
        {title && (
          <StyledH2 looksLike="h3" variant={['simpleBit', 'regular', hasImage && 'hasImage']}>
            <PortableText
              source={insertFootnoteReference({
                footnote,
                text: title,
              })}
              typeSerializers={getFootnoteSerializer({ footnote, variant: 'footnote' })}
            />
          </StyledH2>
        )}
        {hasImage && (
          <StyledImageWrapper>
            {/* @ts-expect-error - Automatic, Please fix when editing this file */}
            <Image src={image.src} alt={image.alt ?? ''} />
          </StyledImageWrapper>
        )}
      </StyledContainer>
    </WrappedSection>
  );
};

export default StripSection;
